export default "__VITE_ASSET__BdPnCDH0__"